import {
    CircularProgress,
    Dropdown,
    fetchRoute,
    ListModel,
    ListsFactory,
    TGenericListReturn
} from "@cakemail-org/ui-components-v2"
import { useEffect, useRef, useState } from "react"
import { TListSearch } from "./types"
import { logError } from "../../utils/data"
import { useTranslation } from "react-i18next"
import { TDropMenuItem } from "@cakemail-org/ui-components-v2/dist/esm/components/dropMenu/types"
import { ERoutes } from "../../utils/url"
import "./styles.scss"
import { SelectChangeEvent } from "@mui/material"
import { ELogErrorMsg } from "../../utils/data/types"

export function ListSearch({ maxItems = 25, addCreate = false, initValue, onChange, onFirstListLoaded, label }: TListSearch) {
    const { t } = useTranslation()
    const [search, setSearch] = useState("")
    const [lists, setLists] = useState<TGenericListReturn<ListModel>>()
    const [selectedList, setSelectedList] = useState<string>(initValue ? String(initValue) : "")
    const initialCount = useRef<number>(0)
    const maxDDItems = useRef(maxItems)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        fetchLists()
    }, [search])

    function handleListChange(event: SelectChangeEvent<string>) {
        const { name, value } = event.target
        const foundList = lists?.data.find((list) => list.id.toString() === value)
        if (foundList) {
            setSelectedList(String(foundList.id))
            onChange && onChange(foundList)
        }
    }

    function handleSearch(search: string) {
        setSearch(search)
    }


    function handleCreateList() {
        window.location.href = "#" + fetchRoute({ route: ERoutes.createList })
    }

    function handleViewAllLists() {
        // TODO: Implement view all lists
    }

    function fetchLists() {
        setLoading(true)
        ListsFactory.list({
            filter: search ? `name==*${search}*` : undefined,
            perPage: maxDDItems.current,
            page: 1,
            withCount: true
        }).then((lists) => {
            if (!initialCount.current) {
                initialCount.current = lists.pagination.count || 0
            }
            onFirstListLoaded && onFirstListLoaded(lists.data[0])

            setLists(lists)

            if (!initValue && lists.data[0]) {
                setSelectedList(String(lists.data[0].id))
            }
        }).catch((error) => {
            logError(ELogErrorMsg.ErrorFetchingLists, error)
        }).finally(() => {
            setLoading(false)
        })
    }


    const options: TDropMenuItem[] = lists?.data.map((item) => {
        return {
            text: item.name,
            value: item.id.toString(),
        }
    }) || [{
        text: <CircularProgress size={20} variant="indeterminate" />,
        className: "innerLoading",
        value: "loading",
        isAction: true,
        isTitle: true
    }]


    if (lists) {
        if (initialCount.current > maxDDItems.current || search !== "") {
            if (lists?.pagination?.count !== 0) {
                options.unshift({
                    isTitle: true,
                    text: t("search-refine-result", {
                        count: lists?.data?.length,
                        total: initialCount.current,
                    }),
                    value: "refineText"
                })
            } else if (lists?.pagination?.count === 0) {
                options.unshift({
                    isTitle: true,
                    text: t("list-listing-empty-search-title"),
                    value: "refineText"
                })
            }
        }

        if (addCreate) {
            options.push({
                text: t("general-create-list"),
                value: "createList",
                className: "createList",
                isAction: true,
                onClick: handleCreateList,
            })
        }
    }

    const ddReady = !!(selectedList && lists)

    return <Dropdown
        label={label}
        size="large"
        key={ddReady ? "ready" : "no-ready"}
        className="listSearch-dropdown"
        options={options}
        placeholder={t("general-select-list")}
        value={(selectedList && lists) ? selectedList : undefined}
        onChange={handleListChange}
        searchProps={{
            onChange: handleSearch,
            placeholder: t("list-search-placeholder")
        }}
        stickyActions={undefined/*initialCount.current > 1 &&
            <Button variant="contained" color="primary" onClick={handleViewAllLists}>
                {t("general-view-all-lists")}
            </Button>
        */}
    />
}

export default ListSearch